export const ColorCoding = {
  PRE_DUE: {
    min: 0,
    max: 0,
    color: {
      TOP_CHIP_COLOR: '#158E44',
      TOP_CHIP_BG_COLOR: '#D3F8E1',
      CARD_COLOR: '#E4FBED',
      TOTAL_AMOUNT_COLOR: 'var(--grayscale-2)'
    }
  },
  D0: {
    min: 0,
    max: 0,
    color: {
      TOP_CHIP_COLOR: '#34A100',
      TOP_CHIP_BG_COLOR: '#E8F9DC',
      CARD_COLOR: '#F0FCE8',
      TOTAL_AMOUNT_COLOR: 'var(--grayscale-2)'
    }
  },
  D1_D3: {
    min: 1,
    max: 3,
    color: {
      TOP_CHIP_COLOR: 'var(--yellow-dark)',
      TOP_CHIP_BG_COLOR: 'var(--pale-yellow)',
      CARD_COLOR: 'var(--yellow-chilean)',
      TOTAL_AMOUNT_COLOR: 'var(--grayscale-2)'
    }
  },
  D4_D6: {
    min: 4,
    max: 6,
    color: {
      TOP_CHIP_COLOR: 'var(--orange-dark)',
      TOP_CHIP_BG_COLOR: 'var(--orange-oldlase)',
      CARD_COLOR: 'var(--orange-light)',
      TOTAL_AMOUNT_COLOR: 'var(--grayscale-2)'
    }
  },
  D7_D30: {
    min: 7,
    max: 30,
    color: {
      TOP_CHIP_COLOR: 'var(--red-crisis)',
      TOP_CHIP_BG_COLOR: 'var(--pale-red)',
      CARD_COLOR: 'var(--red-grayish)',
      TOTAL_AMOUNT_COLOR: 'var(--red-base)'
    }
  }
};

export enum COLOR_CODING {
  TOP_CHIP_COLOR = 'TOP_CHIP_COLOR',
  TOP_CHIP_BG_COLOR = 'TOP_CHIP_BG_COLOR',
  CARD_COLOR = 'CARD_COLOR',
  TOTAL_AMOUNT_COLOR = 'TOTAL_AMOUNT_COLOR'
}

export enum AGENT_AVAILABILITY {
  AGENT_ONLINE = 'AGENT_ONLINE',
  AGENT_OFFLINE = 'AGENT_OFFLINE',
  AGENT_IDLE = 'AGENT_IDLE'
}

export const DAYS_PAST_DUE = {
  DUE_TODAY: 'Due Today',
  DUE_DAYS: 'days',
  DUE_DAY: 'day'
};

export const SLACK_NOTIFICATION_INTERVAL = 3e4;

export const noImageFoundText = 'No Image available';

export const ameyoErroneousErrorMessage =
  'Ameyo is facing an error! Meanwhile, you can submit the feedback.';

export const ameyoErroneousCallWaitingScreenText = {
  title: 'Ameyo is facing an error!',
  subHeading: 'You will start receiving calls once it is fixed.'
};

export const HRC_ALERTS_SLACK_CHANNEL = 'HRC_ALERTS';

export const spadeCallingCampaignId = '61';

export const firstInteractionMessage = '1st call answered for this EMI';

export const PreviousReminderRefId = 'PreviousReminderRefId';

export const HrcDisconnectTextConstants = {
  DISCONNECT: 'Disconnect',
  DISCONNECTING: 'Disconnecting',
  DISCONNECTED: 'Disconnected'
};

export enum BACKEND_AUDIT_STATUSES {
  ACTIVE = 'ACTIVE',
  DISCONNECTED = 'DISCONNECTED',
  DISPOSED = 'DISPOSED'
}

export const HRC_API_TIMEOUT = 3000;
